module.exports = __webpack_public_path__ + "img/expand-collapse.e919bf0e.svg";